module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (204).18a6026b.jpg";